import React from 'react';
import { Field } from 'redux-form';
import { RadioButtonGroupInput } from 'react-admin';
import { FormDataConsumer, required } from 'react-admin';

import DbSourceChoices from '../StaticData/DbSourceChoices';
import SourceMongo from './SourceMongo';
import SourceRedshift from './SourceRedshift';

type Props = {
  record: any
};

const SourcesTab = (props: Props) => (
  <div>
    <div>
      <Field
        choices={DbSourceChoices}
        component={RadioButtonGroupInput}
        label="Database Source"
        name="source"
        options={{ style: { display: 'inline' } }}
        source="source"
      />
    </div>

    <FormDataConsumer>
      {({ formData, ...rest }) => (formData &&
        (formData.source === 'Redshift BI Ads' ||
          formData.source === 'Redshift RTB')) &&
        <SourceRedshift record={props.record} />
      }
    </FormDataConsumer>

    <FormDataConsumer>
      {({ formData, ...rest }) => formData && (formData.source === 'MongoDB') &&
        <SourceMongo record={props.record} />
      }
    </FormDataConsumer>
  </div>
);

export default SourcesTab;



// WEBPACK FOOTER //
// ./src/views/Components/Monitors/Partials/SourcesTab.tsx